<template>
<transition name="slide">
    <div v-show="contain || otherPhoneContain" class="course_detail">
        <div class="back_nav" >
            <a href="javascript:void(0);" class="back" @click="$parent.updateCourseInfo({phoneType:''})"><img class="img" src="./images/back.png" /></a>
            <p class="p">{{courseInfo.phoneType}}</p>
        </div>
        <Scrapper class="examples">
            <div class="harmonyOS" v-show="courseInfo.phoneType=='华为鸿蒙系统'">
                <div class="harmonyOS_1">
                    <img v-if="courseInfo.applogo" class="app_logo" :src="courseInfo.applogo" />
                    <p v-if="courseInfo.appName" class="app_name">{{courseInfo.appName}}</p>
                    <img class="img" src="./images/harmonyOS_bg1.jpg" />
                </div>
                <img class="img" src="./images/harmonyOS_bg2.jpg" />
                <img class="img" src="./images/harmonyOS_bg3.jpg" />
                <img class="img" src="./images/harmonyOS_bg4.jpg" />
                <img class="img" src="./images/harmonyOS_bg5.jpg" />
                <img class="img" src="./images/harmonyOS_bg6.jpg" />
                <div class="harmonyOS_1">
                    <img v-if="courseInfo.applogo" class="app_logo" :src="courseInfo.applogo" />
                    <p v-if="courseInfo.appName" class="app_name">{{courseInfo.appName}}</p>
                    <img class="img" src="./images/harmonyOS_bg7.jpg" />
                </div>
                <div class="harmonyOS_1">
                    <img v-if="courseInfo.applogo" class="app_logo" :src="courseInfo.applogo" />
                    <p v-if="courseInfo.appName" class="app_name">{{courseInfo.appName}}</p>
                    <img class="img" src="./images/harmonyOS_bg8.jpg" />
                </div>
                <div class="harmonyOS_1">
                    <img v-if="courseInfo.applogo" class="app_logo" :src="courseInfo.applogo" />
                    <p v-if="courseInfo.appName" class="app_name">每天更新 精彩不断</p>
                    <img class="img" src="./images/harmonyOS_bg9.jpg" />
                </div>
            </div>
            <div v-show="courseInfo.phoneType=='华为手机安装说明'">
                <img class="brand huawei" src="./images/huawei.png" />
                <div class="list">
                    <span class="step">1</span>
                    <p>下载后会弹出风险框，请不用担心，{{courseInfo.appName}}没有任何病毒，请点击「暂不处理」</p>
                </div>
                <div class="post huawei_1">
                    <img v-if="courseInfo.applogo" class="app_logo" :src="courseInfo.applogo" />
                    <p v-if="courseInfo.appName" class="app_name">{{courseInfo.appName}}</p>
                    <img class="img" src="./images/huawei_03.jpg" >
                </div>
                <div class="list">
                    <span class="step">2</span>
                    <p>安装后打开<span class="fc_002000">「信任次应用」</span>即可</p>
                </div>
                <div class="post">
                    <img class="img" src="./images/huawei_06.jpg" >
                </div>
                <div class="list">
                    <span class="step">3</span>
                    <p>华为自带的「手机管家」中会检测出敏感内容由于{{courseInfo.appName}}中包含成人内容所致，放心使用</p>
                </div>
                <div class="post huawei_2">
                    <img v-if="courseInfo.applogo" class="app_logo" :src="courseInfo.applogo" />
                    <p v-if="courseInfo.appName" class="app_name">{{courseInfo.appName}}</p>
                    <img class="img" src="./images/huawei_08.jpg" >
                </div>
            </div>
            <div v-show="courseInfo.phoneType=='小米手机安装说明'" class="release_risk">
                <img src="./images/other_xiaomi1.jpg">
                <img src="./images/other_xiaomi2.jpg">
                <div class="other_xiaomi_logo">
                    <img v-if="courseInfo.applogo" class="app_logo" :src="courseInfo.applogo" />
                    <p v-if="courseInfo.appName" class="app_name">{{courseInfo.appName}}</p>
                    <img class="img" src="./images/other_xiaomi3.jpg" >
                </div>
                <div class="other_xiaomi_logo">
                    <img v-if="courseInfo.applogo" class="app_logo" :src="courseInfo.applogo" />
                    <p v-if="courseInfo.appName" class="app_name">{{courseInfo.appName}}</p>
                    <img class="img" src="./images/other_xiaomi4.jpg" >
                </div>
                <!-- <img src="./images/other_xiaomi5.jpg"> -->
            </div>
            <div v-show="courseInfo.phoneType=='OPPO手机安装说明'" class="release_risk">
                <img src="./images/other_oppo1.jpg">
                <div class="other_oppo_logo">
                    <img v-if="courseInfo.applogo" class="app_logo" :src="courseInfo.applogo" />
                    <p v-if="courseInfo.appName" class="app_name">{{courseInfo.appName}}</p>
                    <img class="img" src="./images/other_oppo2.jpg" >
                </div>
                <div class="other_oppo_logo">
                    <img v-if="courseInfo.applogo" class="app_logo" :src="courseInfo.applogo" />
                    <p v-if="courseInfo.appName" class="app_name">{{courseInfo.appName}}</p>
                    <img class="img" src="./images/other_oppo3.jpg" >
                </div>
                <div class="other_oppo_logo">
                    <img v-if="courseInfo.applogo" class="app_logo" :src="courseInfo.applogo" />
                    <p v-if="courseInfo.appName" class="app_name">{{courseInfo.appName}}</p>
                    <img class="img" src="./images/other_oppo4.jpg" >
                </div>
                <!-- <img src="./images/other_oppo5.jpg"> -->
            </div>
            <div v-show="courseInfo.phoneType=='VIVO手机安装说明'">
                <img  class="brand vivo" src="./images/vivo.png" />
                <div class="list">
                    <span class="step">1</span>
                    <p>下载后会弹出风险框，请点击<span class="fc_002000">「继续安装」</span></p>
                </div>
                <div class="post vivo_1">
                    <img v-if="courseInfo.applogo" class="app_logo" :src="courseInfo.applogo" />
                    <p v-if="courseInfo.appName" class="app_name">{{courseInfo.appName}}</p>
                    <img class="img" src="./images/vivo_03.jpg" >
                </div>
                <div class="list">
                    <span class="step">2</span>
                    <p>在<span class="fc_002000">「高风险提示」</span>弹框出现后点击安装，如没有安装，请重复第一步并点击<span class="fc_002000">「忽略风险并安装」</span></p>
                </div>
                <div class="post vivo_2">
                    <img v-if="courseInfo.applogo" class="app_logo" :src="courseInfo.applogo" />
                    <p v-if="courseInfo.appName" class="app_name">{{courseInfo.appName}}</p>
                    <img class="img" src="./images/vivo_06.jpg" >
                </div>
            </div>
            <div v-show="courseInfo.phoneType=='魅族手机安装说明'" class="release_risk">
                <img src="./images/other_meizu1.jpg">
                <div class="other_meizu_logo">
                    <img v-if="courseInfo.applogo" class="app_logo" :src="courseInfo.applogo" />
                    <p v-if="courseInfo.appName" class="app_name">{{courseInfo.appName}}</p>
                    <img class="img" src="./images/other_meizu2.jpg" >
                </div>
                <div class="other_meizu_logo other_meizu_logo2">
                    <img v-if="courseInfo.applogo" class="app_logo" :src="courseInfo.applogo" />
                    <p v-if="courseInfo.appName" class="app_name">{{courseInfo.appName}}</p>
                    <img class="img" src="./images/other_meizu3.jpg" > 
                </div>
                <!-- <img src="./images/other_meizu4.png"> -->
            </div>
     
            <div v-show="courseInfo.phoneType=='一加手机安装说明'" class="release_risk">
                <img src="./images/other_1plus1.jpg">
                <div class="other_plus_logo">
                    <img v-if="courseInfo.applogo" class="app_logo" :src="courseInfo.applogo" />
                    <p v-if="courseInfo.appName" class="app_name">{{courseInfo.appName}}</p>
                    <img class="img" src="./images/other_1plus2.jpg" >
                </div>
                <div class="other_plus_logo">
                    <img v-if="courseInfo.applogo" class="app_logo" :src="courseInfo.applogo" />
                    <p v-if="courseInfo.appName" class="app_name">{{courseInfo.appName}}</p>
                    <img class="img" src="./images/other_1plus3.jpg" >
                </div>
                <!-- <img src="./images/other_1plus4.jpg"> -->
                
            </div>
            <div v-show="courseInfo.phoneType=='Realme手机安装说明'" class="release_risk">
                <div class="other_realme_logo">
                    <img v-if="courseInfo.applogo" class="app_logo" :src="courseInfo.applogo" />
                    <p v-if="courseInfo.appName" class="app_name">{{courseInfo.appName}}</p>
                    <img class="img" src="./images/other_realme1.jpg" >
                </div>
                <div class="other_realme_logo">
                    <img v-if="courseInfo.applogo" class="app_logo" :src="courseInfo.applogo" />
                    <p v-if="courseInfo.appName" class="app_name">{{courseInfo.appName}}</p>
                    <img class="img" src="./images/other_realme2.jpg" >
                </div>
                <div class="other_realme_logo">
                    <img v-if="courseInfo.applogo" class="app_logo" :src="courseInfo.applogo" />
                    <p v-if="courseInfo.appName" class="app_name">{{courseInfo.appName}}</p>
                    <img class="img" src="./images/other_realme3.jpg" >
                </div>
                <!-- <img src="./images/other_realme4.jpg"> -->
            </div>
            <div v-show="courseInfo.phoneType=='IQOO手机安装说明'" class="release_risk">
                <img src="./images/other_iQOO1.jpg">
                <div class="other_iQOO_logo">
                    <img v-if="courseInfo.applogo" class="app_logo" :src="courseInfo.applogo" />
                    <p v-if="courseInfo.appName" class="app_name">{{courseInfo.appName}}</p>
                    <img class="img" src="./images/other_iQOO2.jpg" >
                </div>
                <div class="other_iQOO_logo">
                    <img v-if="courseInfo.applogo" class="app_logo" :src="courseInfo.applogo" />
                    <p v-if="courseInfo.appName" class="app_name">{{courseInfo.appName}}</p>
                    <img class="img" src="./images/other_iQOO3.jpg" >
                </div>
                <!-- <img src="./images/other_iQOO4.jpg"> -->
            </div>
            <div v-show="courseInfo.phoneType=='三星手机安装说明'" class="release_risk">
                <img src="./images/other_samsung1.jpg">
                <div class="other_samsung_logo">
                    <img v-if="courseInfo.applogo" class="app_logo" :src="courseInfo.applogo" />
                    <p v-if="courseInfo.appName" class="app_name">{{courseInfo.appName}}</p>
                    <img class="img" src="./images/other_samsung2.jpg" >
                </div>
                <div class="other_samsung_logo">
                    <img v-if="courseInfo.applogo" class="app_logo" :src="courseInfo.applogo" />
                    <p v-if="courseInfo.appName" class="app_name">{{courseInfo.appName}}</p>
                    <img class="img" src="./images/other_samsung3.jpg" >
                </div>
                <!-- <img src="./images/other_samsung4.jpg"> -->
            </div>
            <div v-show="courseInfo.phoneType=='其他手机安装说明'">
                <img  class="brand oppo" src="./images/other.png" />
                <div class="list">
                    <span class="step">1</span>
                    <p>下载前请先至<span class="fc_002000">「设置」</span><span class="fc_002000">「安全性」</span></p>
                </div>
                <div class="post">
                    <img class="img" src="./images/other_03.jpg" >
                </div>
                <div class="list">
                    <span class="step">2</span>
                    <p>开启<span class="fc_002000">「不明的来源」</span>，并执行<span class="fc_002000">「确定」</span></p>
                </div>
                <div class="post">
                    <img class="img" src="./images/other_06.jpg" >
                </div>
            </div>
            <div v-show="['华为手机安装说明','VIVO手机安装说明','其他手机安装说明'].includes(courseInfo.phoneType)" >
                <h1 class="h1">腾讯手机管家设置</h1>
                <div class="list">
                    <span class="step">1</span>
                    <p>打开「腾讯手机管家」后点击<span class="fc_002000">「安全检测」</span></p>
                </div>
                <div class="post">
                    <img class="img" src="./images/comm_10.jpg" >
                </div>
                <div class="list">
                    <span class="step">2</span>
                    <p>在安全检测后点击<span class="fc_002000">「处理」</span></p>
                </div>
                <div class="post comm_1">
                    <img v-if="courseInfo.applogo" class="app_logo" :src="courseInfo.applogo" />
                    <p v-if="courseInfo.appName" class="app_name">{{courseInfo.appName}}</p>
                    <img class="img" src="./images/comm_12.jpg" >
                </div>
                <div class="list">
                    <span class="step">3</span>
                    <p>继续下一步，点击<span class="fc_002000">「移入信任区」</span></p>
                </div>
                <div class="post comm_2">
                    <img v-if="courseInfo.applogo" class="app_logo" :src="courseInfo.applogo" />
                    <p v-if="courseInfo.appName" class="app_name">{{courseInfo.appName}}</p>
                    <img class="img" src="./images/comm_14.jpg" >
                </div>
                <div class="list">
                    <span class="step">4</span>
                    <p>点击<span class="fc_002000">「确认」</span>后，白名单添加成功，再次杀毒 就不会提示了</p>
                </div>
                <div class="post comm_3">
                    <img v-if="courseInfo.applogo" class="app_logo" :src="courseInfo.applogo" />
                    <p v-if="courseInfo.appName" class="app_name">{{courseInfo.appName}}</p>
                    <img class="img" src="./images/comm_16.jpg" >
                </div>
            </div>
            <div class="other_tips" v-show="courseInfo.phoneType=='其它异常Tips'">
                <div class="post tips_1">
                    <img class="img" src="./images/tips_1.png" >
                </div>
                <div class="post tips_2">
                    <img v-if="courseInfo.applogo" class="app_logo" :src="courseInfo.applogo" />
                    <p v-if="courseInfo.appName" class="app_name">{{courseInfo.appName}}</p>
                    <img class="img" src="./images/tips_3.png" >
                </div>
                <div class="post tips_3">
                    <img class="img" src="./images/tips_2.png" >
                </div>
            </div>
            <div v-show="courseInfo.phoneType=='解除风险'" class="release_risk">
                <img src="./images/release_risk_bg1.jpg">
                <img src="./images/release_risk_bg2.jpg">
                <img src="./images/release_risk_bg3.jpg">
                <img src="./images/release_risk_bg4.jpg">
                <img src="./images/release_risk_bg5.jpg">
            </div>
        </Scrapper>
    </div>
</transition>
</template>
<script>
import Scrapper from '@/libaray/component/Scrapper'
import './css/courseand.scss'
export default {
    props:{
        viewInfo:Object
    },
    data: function() {
        return {
            containItem: ['安装说明','Tips','解除'],
            otherPhoneContainItem: ['OPPO','小米','iQOO','一加','realme','三星','魅族18','华为'],
        }
    },
    computed: {
        courseInfo(){
            return{
                phoneType:'',
                applogo:null,
                appName:'',
                show:false,
                ...this.viewInfo
            }
        },
        contain(){
            for (const item of this.containItem) {
                if (this.courseInfo.phoneType.includes(item)) {
                    return true
                }
            }
            return false
        },
        otherPhoneContain(){
            for (const item of this.otherPhoneContainItem) {
                if (this.courseInfo.phoneType.includes(item)) {
                    return true
                }
            }
            return false
        }
    },
    components:{ Scrapper },
    methods: {
        choose(params){
            this.courseInfo.phoneType=params;
        },
    },
    mounted(){
        
    }
};
</script>
<style lang="scss" scoped>
.slide-enter-active{
    transition: 0.1s all ease-out;
    transform: translateX(100%);
}
.slide-enter-to{
    transform: translateX(0%);
}
.slide-leave-active{
    transition: 0.1s all ease-out;
    transform: translateX(0%);
}
.slide-leave-to{
    transform: translateX(100%);
}
.release_risk img{
    width: 100%;
    display: block;
    height: auto;
    flex: 0 0 auto;
}
</style>
